import { t } from "ttag";

import {
  MONTHLY_CAP_CREDIT,
  REFERRAL_CREDIT_AMOUNT,
} from "@/shared/domains/referral";
import type { ModalProps } from "@/shared/models/legacy-types";
import { Card, Dialog, LightbulbIcon } from "@/shared/ui";

export const HowDoesItWorkModal = ({ onClose, show }: ModalProps) => {
  const HOW_DOES_IT_WORK_STEPS = [
    t`Share your unique referral code with friends and family.`,
    t`They use the code when they sign up.`,
    t`They get $${REFERRAL_CREDIT_AMOUNT} off their first month and you get $${REFERRAL_CREDIT_AMOUNT} in LevelsRx account credit!`,
  ] as const;

  const ADDITIONAL_TERMS = [
    t`You'll receive your referral credit once the person you referred has been an active LevelsRx member for 30 days.`,
    t`Credit can be applied to upcoming subscription charges.`,
    t`Discounts cannot be transferred or redeemed for cash value. Credit expires once you leave the LevelsRx program.`,
    t`Sharing a referral code does not make you an affiliate or representative of LevelsRx Health.`,
    t`You can apply up to $${MONTHLY_CAP_CREDIT} in credit monthly.`,
    t`Credit applies to all subscription fees.`,
  ] as const;

  return (
    <Dialog.Root open={show} onOpenChange={onClose}>
      <Dialog.Content>
        <Dialog.Header icon={LightbulbIcon}>
          <Dialog.Title>{t`How does it work?`}</Dialog.Title>

          <Dialog.Description className="sr-only">
            {t`This modal explains how the referral program works, showing the steps to share a code.`}
          </Dialog.Description>
        </Dialog.Header>

        <div className="flex flex-col gap-4 md:gap-6">
          <section className="flex flex-col gap-2">
            {HOW_DOES_IT_WORK_STEPS.map((step, index) => (
              <Card.Root key={step}>
                <Card.Description className="text-base font-medium">
                  {index + 1}. {step}
                </Card.Description>
              </Card.Root>
            ))}
          </section>

          <section className="flex flex-col items-center gap-4 md:gap-6">
            <Dialog.Title>{t`Additional terms`}</Dialog.Title>

            <div className="flex flex-col gap-2">
              {ADDITIONAL_TERMS.map((term) => (
                <Card.Root key={term} className="bg-transparent">
                  <Card.Description className="text-base font-medium">
                    {term}
                  </Card.Description>
                </Card.Root>
              ))}
            </div>
          </section>
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
};
